import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import _ from 'lodash';
import { ACCEPTANCE_CANDIDATES } from '../../../define/consts/solution';
import { findCandidatesLabel, makeBgImage } from '../../../helpers/common';
import { propBool, propFunc, propShape, } from '../../../helpers/custom-prop-types';
import { viewPrice } from '../../../helpers/solution';
import HtmlLink from '../Common/HtmlLink';
import FitButton from './FitButton';
const SearchItem = (props) => {
    const { isPre, item, showExaminationModal } = props;
    const { acceptance, id, period, point, price, solutionMiddleClass, thumbnail, title, } = item;
    const pointRows = (point || '')
        .split('\n')
        .filter((row) => row)
        .map((row, index) => ({
        index,
        row,
    }));
    return (_jsx("section", { children: _jsxs(HtmlLink, Object.assign({ className: 'pointer section-inner', isNoLinkComponent: isPre ? 'div' : undefined, onClickNoLink: showExaminationModal, target: '_blank', to: `/solutions/${id}` }, { children: [_jsxs("div", Object.assign({ className: 'search-image is-thumbnail-cover', style: makeBgImage(thumbnail) }, { children: [_jsx(FitButton, { isDemo: false, item: item, onControlClick: isPre ? showExaminationModal : undefined }), _jsx("div", Object.assign({ className: 'sub-theme' }, { children: _.get(solutionMiddleClass, 'name') }))] })), _jsxs("div", Object.assign({ className: 'search-text' }, { children: [_jsx("h1", { children: title }), _jsx("div", { children: _jsxs("ul", Object.assign({ className: 'sub-info' }, { children: [_jsx("li", { children: `${viewPrice(price)}万円程度` }), _jsx("li", { children: `約${period}週間` }), _jsx("li", { children: findCandidatesLabel(ACCEPTANCE_CANDIDATES, acceptance) })] })) }), _jsx("div", Object.assign({ className: 'pjt-point' }, { children: _jsx("ul", { children: pointRows.map(({ index, row }) => (_jsx("li", { children: row }, index))) }) }))] }))] })) }));
};
SearchItem.propTypes = {
    isPre: propBool().isRequired,
    item: propShape().isRequired,
    showExaminationModal: propFunc().isRequired,
};
export default SearchItem;
